import { useDispatch } from 'react-redux';
import NsContent from 'components/common/ns-content/NsContent';

import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { setPaymentMethod } from 'state/payment-method/payment-method-slice';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsForm } from 'components/common/ns-form/NsForm';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsSelector } from 'components/common/ns-selector/NsSelector';
import { PAYMENT_METHODS } from 'config/app-config';
import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { useNavigation } from 'hooks/useNavigation';

export const testId = 'directDebitTypeTestId';

export const DirectDebitType = () => {
  const dispatch = useDispatch();
  const { next, eventTypes } = useNavigation();

  const handleChange = (event) => {
    const { value } = event.target;
    dispatch(setPaymentMethod(value));
  };

  const handleGoNext = () => {
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <NsPanel testId={testId}>
      <NsBackCta />
      <NsContent>
        <NsTitle title="Choose your payment type" />
      </NsContent>

      <NsForm onSubmit={handleGoNext}>
        <NsSelector
          name="directDebitType"
          onChange={handleChange}
          options={[
            {
              value: PAYMENT_METHODS.QUATERLY_VARIABLE_DIRECT_DEBIT,
              title: 'Quarterly Variable Direct Debit',
              description: `You pay for the amount of energy you use over each 
                              billing period`
            },
            {
              value: PAYMENT_METHODS.MONTHLY_DIRECT_DEBIT,
              title: 'Fixed Direct Debit',
              description: `Spread the cost of your energy throughout the year 
                              so that you don't face higher bills in the winter 
                              when you're likely to use more energy`
            }
          ]}
        />
        <NsAlert
          state="info"
          heading="It’s the rates that are fixed not your total bill"
        >
          <p>
            The amount you pay per unit for your energy is fixed, but if you use
            more gas or electricity your bill will reflect that. If you pick a
            fixed Direct Debit, it will be reviewed twice a year to account for
            higher or less usage so your payments stay on track.
          </p>
        </NsAlert>
        <NsPrimaryCta>Continue</NsPrimaryCta>
      </NsForm>
    </NsPanel>
  );
};

export default DirectDebitType;
